var _excluded = ["iconType"];
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// Inspired by react-hot-toast library

import { AlertCircleSolidIcon, AlertTriangleSolidIcon, CircleIcon, EmptyIcon, LoadingIcon } from '@bfe/moly-icons';
import React, { useEffect, useState } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var TOAST_LIMIT = 3;
var TOAST_REMOVE_DELAY = 3000;
var EToastType = /*#__PURE__*/function (EToastType) {
  EToastType["SUCCESS"] = "success";
  EToastType["FAIL"] = "fail";
  EToastType["INFO"] = "info";
  EToastType["WARN"] = "warn";
  EToastType["PROCESS"] = "process";
  return EToastType;
}(EToastType || {});
var actionTypes = {
  ADD_TOAST: 'ADD_TOAST',
  UPDATE_TOAST: 'UPDATE_TOAST',
  DISMISS_TOAST: 'DISMISS_TOAST',
  REMOVE_TOAST: 'REMOVE_TOAST'
};
var count = 0;
function genId() {
  count = (count + 1) % Number.MAX_VALUE;
  return count.toString();
}
var toastTimeouts = new Map();
var addToRemoveQueue = function addToRemoveQueue(toastId) {
  if (toastTimeouts.has(toastId)) {
    return;
  }
  var timeout = setTimeout(function () {
    toastTimeouts.delete(toastId);
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    if (dispatch) {
      // eslint-disable-next-line @typescript-eslint/no-use-before-define
      dispatch({
        type: 'REMOVE_TOAST',
        toastId: toastId
      });
    }
  }, TOAST_REMOVE_DELAY);
  toastTimeouts.set(toastId, timeout);
};
export var reducer = function reducer(state, action) {
  switch (action.type) {
    case 'ADD_TOAST':
      return _objectSpread(_objectSpread({}, state), {}, {
        toasts: [action.toast].concat(_toConsumableArray(state.toasts)).slice(0, TOAST_LIMIT)
      });
    case 'UPDATE_TOAST':
      return _objectSpread(_objectSpread({}, state), {}, {
        toasts: state.toasts.map(function (t) {
          return t.id === action.toast.id ? _objectSpread(_objectSpread({}, t), action.toast) : t;
        })
      });
    case 'DISMISS_TOAST':
      {
        var toastId = action.toastId;

        // ! Side effects ! - This could be extracted into a dismissToast() action,
        // but I'll keep it here for simplicity
        if (toastId) {
          addToRemoveQueue(toastId);
        } else {
          state.toasts.forEach(function (toast) {
            addToRemoveQueue(toast.id);
          });
        }
        return _objectSpread(_objectSpread({}, state), {}, {
          toasts: state.toasts.map(function (t) {
            return t.id === toastId || toastId === undefined ? _objectSpread(_objectSpread({}, t), {}, {
              open: false
            }) : t;
          })
        });
      }
    case 'REMOVE_TOAST':
      if (action.toastId === undefined) {
        return _objectSpread(_objectSpread({}, state), {}, {
          toasts: []
        });
      }
      return _objectSpread(_objectSpread({}, state), {}, {
        toasts: state.toasts.filter(function (t) {
          return t.id !== action.toastId;
        })
      });
  }
};
var listeners = [];
var memoryState = {
  toasts: []
};
function dispatch(action) {
  memoryState = reducer(memoryState, action);
  listeners.forEach(function (listener) {
    listener(memoryState);
  });
}
function toast(_ref) {
  var iconType = _ref.iconType,
    props = _objectWithoutProperties(_ref, _excluded);
  var id = genId();
  props.title = /*#__PURE__*/_jsxs(_Fragment, {
    children: [iconType === EToastType.SUCCESS && /*#__PURE__*/_jsx(CircleIcon, {
      className: "moly-toast-icon-success"
    }), iconType === EToastType.FAIL && /*#__PURE__*/_jsx(EmptyIcon, {
      className: "moly-toast-icon-fail"
    }), iconType === EToastType.INFO && /*#__PURE__*/_jsx(AlertCircleSolidIcon, {
      className: "moly-toast-icon-info"
    }), iconType === EToastType.WARN && /*#__PURE__*/_jsx(AlertTriangleSolidIcon, {
      className: "moly-toast-icon-warn"
    }), iconType === EToastType.PROCESS && /*#__PURE__*/_jsx(LoadingIcon, {
      className: "moly-toast-icon-process animate-spin"
    }), props.title]
  });
  var update = function update(props) {
    return dispatch({
      type: 'UPDATE_TOAST',
      toast: _objectSpread(_objectSpread({}, props), {}, {
        id: id
      })
    });
  };
  var dismiss = function dismiss() {
    return dispatch({
      type: 'DISMISS_TOAST',
      toastId: id
    });
  };
  dispatch({
    type: 'ADD_TOAST',
    toast: _objectSpread(_objectSpread({}, props), {}, {
      id: id,
      open: true,
      onOpenChange: function onOpenChange(open) {
        if (!open) dismiss();
      }
    })
  });
  return {
    id: id,
    dismiss: dismiss,
    update: update
  };
}
function useToast() {
  var _useState = useState(memoryState),
    _useState2 = _slicedToArray(_useState, 2),
    state = _useState2[0],
    setState = _useState2[1];
  useEffect(function () {
    listeners.push(setState);
    return function () {
      var index = listeners.indexOf(setState);
      if (index > -1) {
        listeners.splice(index, 1);
      }
    };
  }, [state]);
  return _objectSpread(_objectSpread({}, state), {}, {
    toast: toast,
    EToastType: EToastType,
    dismiss: function dismiss(toastId) {
      return dispatch({
        type: 'DISMISS_TOAST',
        toastId: toastId
      });
    }
  });
}
export { EToastType, toast, useToast };